import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { toast } from "sonner";
import { ShieldCheck, BadgeCheck } from "lucide-react";

export default function AdminModeration() {
  const [users, setUsers] = useState([]);
  const load = async () => { try { const { data } = await api.get("/admin/moderation"); setUsers(data); } catch {} };
  useEffect(() => { load(); }, []);
  const suspend = async (id) => { const { data } = await api.post(`/admin/users/${id}/suspend`); toast.success(`User ${data.status}.`); load(); };

  return (
    <div>
      <h1 className="font-head font-black text-4xl tracking-tighter mb-1 flex items-center gap-2"><ShieldCheck className="w-7 h-7" /> Photo Moderation</h1>
      <p className="text-gray-600 font-medium mb-6">Review member photos for community guideline compliance.</p>
      {users.length === 0 ? <div className="bg-white nb-border nb-shadow p-10 text-center font-medium">No photos to moderate.</div> : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {users.map((u) => (
            <div key={u.id} className="bg-white nb-border nb-shadow overflow-hidden" data-testid={`moderate-${u.id}`}>
              <div className="aspect-square bg-[#F3F3F1] overflow-hidden nb-border border-x-0 border-t-0">
                <img src={u.avatar || (u.photos && u.photos[0]) || `https://api.dicebear.com/7.x/thumbs/svg?seed=${u.id}`} alt="" className="w-full h-full object-cover" />
              </div>
              <div className="p-3">
                <div className="font-head font-bold truncate flex items-center gap-1">{u.name}{u.verified_badge && <BadgeCheck className="w-4 h-4 text-[#D4AF37]" fill="#0A0A0A" />}</div>
                <div className="text-xs text-gray-500 mb-2">{u.photos?.length || 0} photos</div>
                <button onClick={() => suspend(u.id)} className="w-full px-2 py-1.5 bg-[#EF4444] text-white nb-border text-xs font-bold uppercase nb-hover">{u.status === "suspended" ? "Unsuspend" : "Suspend"}</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
